import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Row, Col, Form, Input, Button } from "antd";
import LeftContent from "./leftContent";
import { resetPassword } from "@api/auth/auth";
import logoText from "@assets/images/logo/dark-logo-text-nobg.png";
import { SuccessNotification, ErrorNotification } from "@components";
import { Helmet } from "react-helmet-async";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  // Handle Reset Submit
  const handleSubmit = (e) => {
    e.preventDefault();
    // Validate Email
    if (!email) {
      ErrorNotification("Please enter your email");
      return;
    }

    setLoading(true);
    // Make the API call
    resetPassword(email)
      .then((res) => {
        if (res.data.error) {
          ErrorNotification(res.data.type[0].message);
        }
        SuccessNotification(res.data.message);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        ErrorNotification(err.response.data.type[0].message);
      });
  };

  return (
    <>
      <Helmet>
        <title>Forgot Password | Copilotly - Your Personal AI Copilot</title>
        <meta name="description" content="Reset your Copilotly password. Regain access to your AI-powered copilots." />
        <meta name="robots" content="noindex, follow" />
        <link rel="canonical" href="https://app.copilotly.com/forgot-password" />
      </Helmet>

      <Row
        gutter={[32, 0]}
        className="hp-authentication-page"
        style={{ overflowY: "auto", height: "100vh" }}
      >
        <LeftContent />

        <Col
          lg={8}
          md={16}
          sm={16}
          span={24}
          className="hp-py-sm-0 hp-py-md-0"
          justify="center"
        >
          <Row className="hp-h-100" align="middle" justify="center">
            <Col
              xxl={11}
              xl={15}
              lg={20}
              md={16}
              sm={24}
              className="hp-px-sm-8 hp-pt-24 hp-pb-48"
            >
              <img
                src={logoText}
                alt="logo"
                style={{
                  maxWidth: "200px",
                  height: "auto",
                  display: "block",
                  margin: "0 auto",
                }}
              />
              <h2
                className="hp-mb-sm-0"
                style={{
                  textAlign: "center",
                  fontSize: "24px",
                  lineHeight: "32px",
                  color: "rgba(0, 0, 0, 0.85)",
                }}
              >
                Reset Password
              </h2>
              <p
                className="hp-mt-sm-0 hp-mt-8 hp-text-color-black-80"
                style={{
                  textAlign: "center",
                }}
              >
                We’ll e-mail you instructions on how to reset your password.
              </p>

              <Form
                layout="vertical"
                name="basic"
                className="hp-mt-sm-16 hp-mt-32"
              >
                <Form.Item label="Email :">
                  <Input
                    id="validating"
                    placeholder="you@example.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </Form.Item>

                <Form.Item className="hp-mt-16">
                  <Button
                    block
                    type="primary"
                    htmlType="submit"
                    onClick={handleSubmit}
                    loading={loading}
                  >
                    Reset Password
                  </Button>
                </Form.Item>
              </Form>

              <div className="login-create-acc">
                <p>Go back to</p>

                <Link to="/login"> Login</Link>
              </div>

              <Col
                className="hp-other-links hp-mt-24"
                style={{
                  justifyContent: "center",
                  display: "flex",
                }}
              >
                <Link
                  to="/privacy"
                  className="hp-text-color-black-80 hp-text-color-dark-40"
                  style={{
                    marginRight: "8px",
                  }}
                >
                  Privacy Policy
                </Link>

                {/* A dot in between */}
                <span
                  className="hp-text-color-black-80 hp-text-color-dark-40"
                  style={{ margin: "0 8px", fontSize: "12px" }}
                >
                  .
                </span>

                <Link
                  to="/terms"
                  className="hp-text-color-black-80 hp-text-color-dark-40"
                >
                  Terms of Service
                </Link>
              </Col>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default ForgotPassword;
